export default __webpack_public_path__ + "static/website-icon-d0cc6d1934003ce8acd700015b81f95f.png";